import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { nanoid } from 'nanoid';
import React, { useCallback, useEffect, useState } from 'react';
import { useFirstRender } from '../common/effects/useFirstRender';
import { TransferControlColumn } from './transfer-control-column';
import { TransferList } from './transfer-list';
import styles from './transfer.module.scss';
const initMapper = (list) => list.map(item => ({
    id: nanoid(),
    name: item,
    selected: false,
    visible: true,
}));
const Transfer = ({ list1, list2, onChange, enableSearch = false, virtualize = false, focusable = false, size = 'sm', RTL = false, }) => {
    const [leftList, setLeftList] = useState(initMapper(list1));
    const [rightList, setRightList] = useState(initMapper(list2));
    const [leftSelected, setLeftSelected] = useState([]);
    const isFirstRender = useFirstRender();
    const [rightSelected, setRightSelected] = useState([]);
    const transfer = useCallback((dir) => {
        if (dir === 'right') {
            setRightList(prev => prev.concat(leftSelected));
            const leftSelectedIds = leftSelected.map(item => item.id);
            setLeftList(prev => prev.filter(item => !leftSelectedIds.includes(item.id)));
            setRightSelected(prev => prev.concat(leftSelected));
            setLeftSelected([]);
        }
        else {
            setLeftList(prev => {
                return prev.concat(rightSelected);
            });
            const rightSelectedIds = rightSelected.map(item => item.id);
            setRightList(prev => prev.filter(item => !rightSelectedIds.includes(item.id)));
            setLeftSelected(prev => {
                return prev.concat(rightSelected);
            });
            setRightSelected([]);
        }
    }, [leftSelected.length, rightSelected.length]);
    const handleListSelectionLeft = useCallback((sel) => {
        setLeftSelected(sel.map(item => ({
            id: item.id,
            name: item.name,
            selected: true,
            visible: true,
        })));
        const selIds = sel.map(item => item.id);
        setLeftList(prev => prev.map(item => ({
            ...item,
            selected: selIds.includes(item.id),
        })));
    }, []);
    const handleListSelectionRight = useCallback((sel) => {
        setRightSelected(sel.map(item => ({
            id: item.id,
            name: item.name,
            selected: true,
            visible: true,
        })));
        setRightSelected(sel);
        const selIds = sel.map(item => item.id);
        setRightList(prev => prev.map(item => ({
            ...item,
            selected: selIds.includes(item.id),
        })));
    }, []);
    useEffect(() => {
        if (onChange && !isFirstRender.current) {
            onChange(leftList.map(item => item.name), rightList.map(item => item.name));
        }
    }, [leftList.length, rightList.length]);
    return (_jsxs("div", { className: styles.wrapper, children: [_jsx("section", { className: "transfer-column1", children: leftList.length ? (_jsx(TransferList, { listId: "list1", options: leftList, onSelection: handleListSelectionLeft, enableSearch: enableSearch, virtualize: virtualize, focusable: focusable, size: size, RTL: RTL })) : null }), _jsx(TransferControlColumn, { onTransfer: transfer, disableTransferLeft: !rightSelected.length, disableTransferRight: !leftSelected.length, size: size }), _jsx("section", { className: "transfer-column2", children: rightList.length ? (_jsx(TransferList, { listId: "list2", options: rightList, onSelection: handleListSelectionRight, enableSearch: enableSearch, focusable: focusable, size: size, RTL: RTL })) : null })] }));
};
Transfer.displayName = 'Transfer';
export { Transfer };
